<template>
  <div class="claim-team">
    <div class="claim-info">
      <van-image :src="imgView(team.icon)" fit="over" round style="width: 50px; height: 50px"></van-image>
      <div class="match-name">“{{ team.chineseName }}“组委会</div>
      <div style="font-size: 15px; color: #191919; font-weight: 500; margin-top: 7px">邀请您认领球队</div>
      <img class="background" src="../../assets/claim/background.png" alt="">
      <div class="letter">
        <van-image class="logo" :src="imgView(team.badge)" fit="contain" radius="10px"></van-image>
        <div class="team-name">{{ team.name }}</div>
      </div>
      <img class="bottom" src="../../assets/claim/bottom.png" alt="">
      <img src="../../assets/claim/claim.png" class="claim-button" @click="claim">
      <div class="go-home" @click="goHome">前往赛事首页</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {Image as vanImage, Toast} from 'vant'
Vue.use(vanImage)
import { QNImageUtil } from '@/utils'
import { getPassport } from '@/libs/passport'
import {claimTeam, getBMMatchTeamClaimDetail } from "@/api/match";
export default {
  data() {
    return {
      teamId: '',
      matchId: '',
      team: {},
      unionMatchId: ''
    }
  },
  mounted() {
    this.teamId = this.$route.query.teamId
    this.matchId = this.$route.query.matchId
    const params = {
      teamId: this.teamId,
      matchId: this.matchId
    }
    getBMMatchTeamClaimDetail(params).then(res => {
      if (res) {
        const { data } = res
        this.team = data.team
        this.unionMatchId = data.team.unionMatchId
      }
    })
  },
  methods: {
    imgView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    claim() {
      getPassport().then(res => {
        if (res) {
          const params = {
            teamId: this.teamId
          }
          claimTeam(params).then(res => {
            const { data } = res
            if (data.update || data.isClaimedUser) {
              if (data.update) {
                Toast.success('认领成功')
              }
              this.$router.push(`/entry-page/entry-info?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}&teamId=${this.teamId}`)
            } else {
              Toast.fail('球队已被认领')
              this.$router.push(`/union-match/match-overall?unionMatchId=${this.unionMatchId}`)
            }
          })
        }
      })
    },
    goHome() {
      this.$router.push(`/union-match/match-overall?unionMatchId=${this.unionMatchId}`)
    }
  }
}
</script>

<style lang="scss">
.claim-team {
  min-height: 100vh;
  background-image: linear-gradient(#F3F6FD, #DBE7FF, #E7EFFE);
  .claim-info {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding-top: 39px;
    .match-name {
      font-size: 15px;
      color: #191919;
      margin-top: 20px;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow:ellipsis;
    }
    .background {
      position: absolute;
      top: 280px;
      width: 279px;
      height: 296px;
    }
    .letter {
      position: absolute;
      top: 231px;
      width: 258px;
      height: 334px;
      background-image: linear-gradient(#FFF1E0, #FFF7F1);
      border-radius: 12px;
      padding-top: 50px;
      display: flex;
      flex-flow: column;
      align-items: center;
      box-sizing: border-box;
      .logo {
        width: 128px;
        height: 128px;
      }
      .team-name {
        margin-top: 15px;
        color: #191919;
        font-size: 20px;
        font-weight: 500;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow:ellipsis;
      }
    }
    .bottom {
      position: absolute;
      top: 460px;
      width: 279px;
      height: 120px;
    }
    .claim-button {
      position: absolute;
      top: 521px;
      width: 189px;
      height: 44px;
    }
    .go-home{
      position: absolute;
      top: 590px;
      color: #1677FF;
    }
  }
}
.special-bar {
  ::v-deep .bar {
    background-color: #FFFFFF;
  }
}
</style>
